export enum ETipoImposto {
    Icms = 1,
    Ipi = 2,
    Pis = 3,
    Cofins = 4,
    IbsCbs = 5
}
